import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_AAC } from 'services/_path';

// STORE
import { ReducerAction } from 'store/modules/types';

// ACTIONS
import {
	emissaoAtestadoPainelSuccess,
	emissaoAtestadoPainelFailure,
} from './actions';

// TYPES
import { RequestEmissaoAtestado, Types } from './types';

function* emissaoAtestadoPainelRequest(request: ReducerAction) {
	const { payload }: { payload: RequestEmissaoAtestado } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_AAC,
		`aac/${CHANNEL}/emissao-atestado-normal`,
		payload,
	);

	if (response.status === 200) {
		yield put(emissaoAtestadoPainelSuccess(response.data));
	} else if (response.error) {
		yield put(emissaoAtestadoPainelFailure());
	}
}

export default all([
	takeLatest(
		Types.EMISSAO_ATESTADO_PAINEL_REQUEST,
		emissaoAtestadoPainelRequest,
	),
]);
